import { createApp } from 'vue'
import VueAwesomePaginate from "vue-awesome-paginate";
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import "vue-awesome-paginate/dist/style.css";

createApp(App).use(router).use(VueAwesomePaginate).mount('#app')
